module.exports = __webpack_public_path__ + "static/media/google.4ac3c227.webp";